import { tooltipContent } from "@/constants/tooltip"
import { IrrType } from "@/v2/graphql/admin-generated-rq"

export interface irrInfoT {
  flavor: IrrType
  key: "postTaxItcDeprIrr" | "preTaxIrr" | "preTaxItcIrr"
  label: string
  expanded: string
  multiple: number | null | undefined
  val: number | null | undefined
}

export interface metricsT {
  postTaxItcDeprMultiple?: number | null
  postTaxItcDeprIrr?: number | null
  preTaxMultiple?: number | null
  preTaxIrr?: number | null
  preTaxItcMultiple?: number | null
  preTaxItcIrr?: number | null
}

interface Options {
  metrics?: metricsT
}

export const irrInfo = (
  irrFlavor: IrrType | undefined,
  options?: Options,
): irrInfoT => {
  if (irrFlavor == undefined) {
    irrFlavor = IrrType.PostTaxItcDeprIrr
  }

  switch (irrFlavor) {
    case IrrType.PostTaxItcDeprIrr:
      return {
        flavor: IrrType.PostTaxItcDeprIrr,
        key: "postTaxItcDeprIrr",
        label: tooltipContent.postTaxItcDeprIrrLabel,
        expanded: tooltipContent.postTaxItcDeprIrrLabelExpanded,
        multiple: options?.metrics?.postTaxItcDeprMultiple,
        val: options?.metrics?.postTaxItcDeprIrr,
      }
    case IrrType.PreTaxIrr:
      return {
        flavor: IrrType.PreTaxIrr,
        key: "preTaxIrr",
        label: tooltipContent.preTaxIrrLabel,
        expanded: tooltipContent.preTaxIrrLabelExpanded,
        multiple: options?.metrics?.preTaxMultiple,
        val: options?.metrics?.preTaxIrr,
      }
    case IrrType.PreTaxItcIrr:
      return {
        flavor: IrrType.PreTaxItcIrr,
        key: "preTaxItcIrr",
        label: tooltipContent.preTaxItcIrrLabel,
        expanded: tooltipContent.preTaxItcIrrLabelExpanded,
        multiple: options?.metrics?.preTaxItcMultiple,
        val: options?.metrics?.preTaxItcIrr,
      }
    default:
      throw new Error(`Unknown IRR flavor: ${irrFlavor}`)
  }
}
